import styled from "styled-components"

export const Wrapper = styled.div`
  position: relative;
  height: 190px;
  padding-top: 47px;
  box-sizing: border-box;
`
